export const equipmentCodeToName: Record<string, string> = {
  o027: "CT가용(가/부)",
  o028: "MRI가용(가/부)",
  o029: "혈관촬영기가용(가/부)",
  o030: "인공호흡기 일반가용",
  o031: "인공호흡기 조산아가용",
  o032: "인큐베이터가용",
  o033: "CRRT가용",
  o034: "ECMO가용",
  o035: "중심체온조절유도기 가용",
  o037: "고압산소치료기 가용",
};
